import {
    COOKIE_EXPIRATION_DAYS,
    COOKIE_TICA_REFERRAL,
    COOKIE_TICA_REFERRAL_LOGO,
} from '@marketplace/config/cookie.js'
import { getRefererFromRoute } from '@marketplace/helpers/router.js'
import Cookies from 'js-cookie'

/**
 * Set a cookie when referrer by TICA
 *
 * @param {object} context
 * @param {object} context.route
 * @returns void
 */
export default function ({ route }) {
    const referer = getRefererFromRoute(route)
    let isReferral = false

    if (route.path.includes('tica') && !route.path.includes('account/tica')) {
        isReferral = true
    }

    if (referer?.includes('tica.nl')) {
        isReferral = true
    }

    if (route.params.utm_source?.includes('tica')) {
        isReferral = true
    }

    if (isReferral) {
        Cookies.set(COOKIE_TICA_REFERRAL, true, {
            expires: COOKIE_EXPIRATION_DAYS.ONE_YEAR,
            path: '/', // Specifically set the path because the defaults aren't used when updating a cookie
        })

        Cookies.set(COOKIE_TICA_REFERRAL_LOGO, true, {
            expires: '',
            path: '/', // Specifically set the path because the defaults aren't used when updating a cookie
        })
    }
}
